/**
 * JavaScript Utility - format/comma
 * @author 서명환 <mhseo@ulalalab.com>
 */
import number from './number';
import isEmpty from '../isEmpty';
import repeat from '../string/repeat';

function comma(v) {
  if (isEmpty(v) || v === '-') {
    return v;
  }

  const [, precision] = String(v).split('.');

  let formatString = ',0';

  if (!isEmpty(precision)) {
    formatString += `.${repeat('#', precision.length)}`;
  }

  return number(v, formatString);
}

export default comma;
